import { Block } from '@snowflake/core-ui';
import * as React from 'react';

export const CortexLogo = () => {
  return (
    <Block position="absolute" top="24px" left="24px" zIndex={10}>
      <a href="https://www.snowflake.com">
        <img src="/static/images/logo-sno-blue.svg" style={{ width: '102px', height: '24px' }} />
      </a>
    </Block>
  );
};
